"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var const_1 = require("./const");
var vector_functions_1 = require("./vector-functions");
var vf_material_factory_1 = require("./vf-material-factory");
var VFMeshFactory = (function () {
    function VFMeshFactory() {
    }
    VFMeshFactory.CreateTriggerMesh = function (name, trigger, scene, material) {
        if (material === void 0) { material = null; }
        var node = trigger.parentNode;
        var triggerMesh = babylonjs_1.MeshBuilder.CreatePlane(name, { size: const_1.default.TRIGGER_MESH_SCALE }, scene);
        var surrogateNode = new babylonjs_1.TransformNode(name + "_surrogate", scene);
        triggerMesh.setParent(surrogateNode);
        triggerMesh.renderingGroupId = 1;
        surrogateNode.setAbsolutePosition(node.getAbsolutePosition().multiply(vector_functions_1.makeAbs(scene.model.getRoot().scaling)));
        triggerMesh.billboardMode = babylonjs_1.Mesh.BILLBOARDMODE_ALL;
        triggerMesh.setEnabled(true);
        trigger.buttonNode = surrogateNode;
        if (!material) {
            vf_material_factory_1.default.GetEventTriggerMaterial(scene).then(function (mat) {
                triggerMesh.material = mat;
            });
        }
        else {
            triggerMesh.material = material;
        }
        return triggerMesh;
    };
    VFMeshFactory.CreateARPlacementIndicator = function (name, scene) {
        var marker = babylonjs_1.MeshBuilder.CreateGround(name, {
            width: const_1.default.AR_PLACEMENT_MARKER_SIZE,
            height: const_1.default.AR_PLACEMENT_MARKER_SIZE,
        }, scene);
        marker.material = vf_material_factory_1.default.GetPlacementIndicatorMaterial(scene);
        return marker;
    };
    VFMeshFactory.CreateShadowPlane = function (name, size, scene) {
        var shadowPlane = babylonjs_1.MeshBuilder.CreateGround(name, {
            width: size,
            height: size,
        }, scene);
        shadowPlane.material = vf_material_factory_1.default.GetShadowPlaneMaterial(scene);
        shadowPlane.renderingGroupId = 1;
        return shadowPlane;
    };
    VFMeshFactory.CreateDropShadow = function (name, size, scene) {
        var dropShadow = babylonjs_1.MeshBuilder.CreateGround(name, {
            width: size,
            height: size,
        }, scene);
        dropShadow.material = vf_material_factory_1.default.GetDropShadowMaterial(scene);
        dropShadow.renderingGroupId = 1;
        return dropShadow;
    };
    return VFMeshFactory;
}());
exports.default = VFMeshFactory;
